import { ACCOUNTS_URL } from "./apiUrls";
import { AccountsApi } from "@idha/idha-api";

const accountsApi = new AccountsApi({
    baseUrl: ACCOUNTS_URL,
    transformRequest: (data,headers) => {
        headers['Authorization'] = headers['Authorization'] || window.localStorage.getItem('$LoopBack$accessTokenId')

        return JSON.stringify(data)
    },
     interceptors: {
        response: [
            {
                onRejected: (e) => {
                    if (e?.response?.data?.error?.status == 400 &&
                            e?.response?.data?.error?.message) {
                        alert(e?.response?.data?.error?.message)
                    } else {
                        alert(`Houve um erro desconhecido. Contacte o suporte idha`)
                    }
                    
                }
            }
        ]
    }
})

export {accountsApi}